import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Balloon, Icon } from '@alifd/next';
import safeLog from '@alife/bc-safe-log';
import './index.scss';

export default class WarrancyWidget extends Component {
  static propTypes = {
    className: PropTypes.string,
    dtClassName: PropTypes.string,
    ddClassName: PropTypes.string,
    i18n: PropTypes.shape({
      warrancy: PropTypes.string,
      total: PropTypes.string,
      core: PropTypes.string,
      text: PropTypes.string,
    }),
    total: PropTypes.string,
    core: PropTypes.string,
    // scene: PropTypes.string,
    coreInstruction: PropTypes.string,
    balloonClass: PropTypes.string,
    pid: PropTypes.number,
  };

  static defaultProps = {
    className: '',
  };

  onVisibleChange = visible => {
    if (visible) {
      safeLog(
        '/sc.details.commonLogs',
        'CLK',
        `info=pid=${this.props.pid}&action=warrancy_hover`,
        'GET',
      );
    }
  };

  render() {
    const { props } = this;
    const { i18n = {}, total, core } = props;

    if (!total && !core) return null;

    return (
      <dl className={`warrancy-widget ${props.className}`}>
        <dt className={props.dtClassName}>{i18n.warrancy || 'Warrancy:'}</dt>
        <dd className={props.ddClassName}>
          {!!total && (
            <span>
              <b>{total}</b> {i18n.total || 'for machinery warrancy'}
            </span>
          )}
          {!!total && !!core && <span className="ver-split">|</span>}
          {!!core && (
            <span>
              <b>{core}</b> {i18n.core || 'for Core Components'}
            </span>
          )}
          {!!core && (
            <Balloon
              trigger={
                <Icon type="prompt" size="small" className="help-icon" />
              }
              closable={false}
              className={`${props.balloonClass} ins-balloon`}
              align="bl"
              alignEdge
              cache
              onVisibleChange={this.onVisibleChange}
            >
              <div className="ins-balloon-text">
                {i18n.text || 'Core Components include '}
                {props.coreInstruction}
              </div>
            </Balloon>
          )}
        </dd>
      </dl>
    );
  }
}
